"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCancellationReasons = exports.getProvider = exports.getAppointment = exports.deleteAppointment = void 0;
const API_1 = require("../../lib/API");
const deleteAppointment = '@service/DELETE_APPOINTMENT';
exports.deleteAppointment = deleteAppointment;
const getAppointment = '@service/GET_APPOINTMENT';
exports.getAppointment = getAppointment;
const getProvider = '@service/GET_PROVIDER';
exports.getProvider = getProvider;
const fetchCancellationReasons = '@service/FETCH_CANCELLATION_REASONS';
exports.fetchCancellationReasons = fetchCancellationReasons;
const services = {
    [getAppointment]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        return (0, API_1.getAppointmentById)(context.services.getAppointment, (_a = context.appointmentId) !== null && _a !== void 0 ? _a : '');
    }),
    [getProvider]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d;
        return (0, API_1.getProviderById)(context.services.getProvider, (_d = (_c = (_b = context.appointment) === null || _b === void 0 ? void 0 : _b.provider) === null || _c === void 0 ? void 0 : _c.provider_pma_id.toString()) !== null && _d !== void 0 ? _d : '');
    }),
    [deleteAppointment]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        return (0, API_1.cancelAppointmentById)(context.services.cancelAppointment, (_e = context.appointmentId) !== null && _e !== void 0 ? _e : '', context.cancelEmailConsent, context.cancelReasonText);
    }),
    [fetchCancellationReasons]: (context) => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g;
        return (0, API_1.getAppointmentCancellationReasons)(context.services.getCancellationReasons, (_g = (_f = context.appointment) === null || _f === void 0 ? void 0 : _f.source_system) !== null && _g !== void 0 ? _g : '');
    })
};
exports.default = services;
//# sourceMappingURL=services.js.map